import React from 'react';

import LegalPage from '../components/LegalPage';
import { PRIVACY_HTML, PRIVACY_TOC } from '../legal/privacyContent';

const Privacy: React.FC = () => (
  <LegalPage title="Privacy Policy" html={PRIVACY_HTML} toc={PRIVACY_TOC} />
);

export default Privacy;
